export default __webpack_public_path__ + "static/media/download.26eb83d4.png";